<!----
    Author: hjlee
    Description:
        이미지 뷰어 컨트롤
---->
<template>
  <div class="image-viewer-container" @click="onClickImageViewer">
    <div class="clickable hide-button" @click="hideImageViewer($event)">
      <i class="fa fa-remove" aria-hidden="true" />
    </div>
    <div class="image-viewer">
      <b-img
        :src="src"
        :alt="alt?alt:''"
        :class="['image', move ? 'move':'', dragging ? 'dragging' : '']"
        @mousedown="onDragStart($event)"
        @mouseup="onDragEnd($event)"
        @mousemove="onDragOver($event)"
        @mouseleave="onDragEnd($event)"
        @wheel="zoom($event)"
        @load="onLoaded"
      />
    </div>
    <div class="zoom-control">
      <b-button-group>
        <b-button @click="zoom($event, -5)">
          -
        </b-button>
        <b-input-group append="%">
          <b-form-input v-model="ratio" class="ratio-input" max="200" min="10" readonly />
        </b-input-group>
        <b-button @click="zoom($event, 5)">
          +
        </b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      dragging: false,
      move: false,
      ratio: 100
    }
  },
  watch: {
    src: function() {
      this.recalculateLayout()
    }
  },
  mounted() {
    this.$eventHub.$on('keyup', this.onKeyup)
  },
  beforeDestroy() {
    this.$eventHub.$off('keyup', this.onKeyup)
  },
  methods: {
    onClickImageViewer: function(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }
    },
    onLoaded: function(e) {
      this.recalculateLayout()
    },
    zoom($event, delta) {
      const e = $event
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }

      if (!delta) {
        delta = $event.deltaY > 0 ? -10 : 10
      }
      this.ratio = this.ratio + delta
      if (this.ratio < 10) {
        this.ratio = 10
      }
      if (this.ratio > 200) {
        this.ratio = 200
      }
      this.marginTop = 0
      this.marginLeft = 0
      $(this.$el)
        .find('.image')
        .css('margin-top', this.marginTop + 'px')
      $(this.$el)
        .find('.image')
        .css('margin-left', this.marginLeft + 'px')
      this.recalculateLayout()
    },
    recalculateLayout() {
      this.frameWidth = $(this.$el)
        .find('.image-viewer')
        .width()
      this.frameHeight = $(this.$el)
        .find('.image-viewer')
        .height()
      const image = new Image()
      const self = this
      image.onload = function() {
        self.imgWidth = this.width
        self.imgHeight = this.height
        self.resizedImgWidth = (this.width * self.ratio) / 100
        self.resizedImgHeight = (this.height * self.ratio) / 100
        if (
          self.frameWidth < self.resizedImgWidth ||
          self.frameHeight < self.resizedImgHeight
        ) {
          self.move = true
        } else {
          self.move = false
        }
        $(self.$el)
          .find('.image')
          .width(self.resizedImgWidth)
        $(self.$el)
          .find('.image')
          .height(self.resizedImgHeight)
      }
      image.src = $(this.$el)
        .find('.image')
        .attr('src')
    },
    onDragStart: function(e) {
      e.preventDefault()
      this.dragging = true
      this.startX = e.screenX
      this.startY = e.screenY
      this.$forceUpdate()
    },
    onDragEnd: function(e) {
      e.preventDefault()
      if (this.dragging) {
        this.marginTop = this.marginTop + this.marginTopDiff
        this.marginLeft = this.marginLeft + this.marginLeftDiff
        this.marginTopDiff = 0
        this.marginLeftDiff = 0
      }
      this.dragging = false
      this.$forceUpdate()
    },
    onDragOver: function(e) {
      e.preventDefault()
      if (this.dragging) {
        if (this.resizedImgHeight > this.frameHeight) {
          if (
            this.marginTop + e.screenY - this.startY < 0 &&
            this.resizedImgHeight - this.frameHeight >
              -(this.marginTop + e.screenY - this.startY)
          ) {
            this.marginTopDiff = e.screenY - this.startY
          }
        }

        if (this.resizedImgWidth > this.frameWidth) {
          if (
            this.marginLeft + e.screenX - this.startX < 0 &&
            this.resizedImgWidth - this.frameWidth >
              -(this.marginLeft + e.screenX - this.startX)
          ) {
            this.marginLeftDiff = e.screenX - this.startX
          }
        }
        $(this.$el)
          .find('.image')
          .css('margin-top', this.marginTop + this.marginTopDiff + 'px')
        $(this.$el)
          .find('.image')
          .css('margin-left', this.marginLeft + this.marginLeftDiff + 'px')
      }
    },
    showImageViewer() {
      this.ratio = 100
      this.marginTop = 0
      this.marginLeft = 0
      $(this.$el)
        .find('.image')
        .css('margin-top', this.marginTop + 'px')
      $(this.$el)
        .find('.image')
        .css('margin-left', this.marginLeft + 'px')
      $(this.$el).fadeIn()
    },
    hideImageViewer(e) {
      this.vibrate(e)
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }
      $(this.$el).fadeOut()
    },
    onKeyup(e) {
      if (e.keyCode === 27) {
        this.hideImageViewer()
      }
    }
  }
}
</script>

<style scoped>
.image-viewer-container {
  position: fixed;
  display: none;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 2rem;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.7);
}
.image-viewer {
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: auto;
}
img {
  max-width: none !important;
}
.hide-button {
  margin: 5px;
  margin-top: -20px;
  background-color: black;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: 2px solid black;
  float: right;
  text-align: center;
  padding-top: 2px;
}

.image {
  transition: width 0.4s, height 0.4s, opacity 0.4s;
}

.image.move {
  cursor: grab;
}
.image.move.dragging {
  cursor: grabbing !important;
}
.zoom-control {
  position: fixed;
  right: 10px;
  bottom: 10px;
  display: flex;
  align-items: center;
  height: 2.3rem;
}
.zoom-control >>> .input-group {
  border: none;
}
.zoom-control >>> .input-group > .custom-select:not(:last-child),
.zoom-control >>> .input-group > .form-control:not(:last-child),
.zoom-control >>> .input-group > .input-group-append > .input-group-text {
  border-radius: 0;
}
.zoom-control >>> .input-group {
  float: left;
}
.zoom-control >>> .btn {
  height: 2.3rem;
}
.zoom-control >>> .btn-group {
  display: inline-flex;
}
.zoom-control >>> input[type='text'] {
  height: 2.3rem;
  font-size: 1rem;
  border: none;
  box-shadow: none;
}
.zoom-control >>> .input-group-text {
  border: none;
  box-shadow: none;
  height: 2.3rem;
}
.ratio-input {
  width: 50px !important;
}
</style>
